import { request } from './config/utils'

import { Params } from '../../constants'

export function nearNotificationsPostRequest(params) {

    return request('post', params, Params.NEAR_NOTIFICATIONS_POST)
}

export function saveNotificationPostRequest(params) {

    return request('post', params, Params.SAVE_NOTIFICATION_POST)
}